import { Modal } from "antd";
import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../App.css";
import CommonTableModule from "../components/CommonTable/CommonTableModule";
import { hasPermission } from "../utils/usePermission";
import TodayAttendance from "./dashboardCard/TodayAttendance";
import TodayLeave from "./dashboardCard/TodayLeave";
import TodayRestDays from "./dashboardCard/TodayRestDays";
import { DateTimeFormat } from "./DateFormat/DateTimeFormat";
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToast: false,
      totalEmployees: 0,
      showModal: false,
      totalExpenses: 0,
      totalPayments: 0,
      recentApplications: [],
      leavesToday: [],
      restDays: [],
      attendance: [],
      loading: true,
      attendanceData: [],
      username: ''
    };
  }


  async componentDidMount() {
    let token = localStorage.getItem('token');
    axios({
      method: "get",
      url: "/checkToken",
      headers: { "Authorization": `Bearer ${token}` }
    })
      .then((res) => {
        this.setState({ isAuthenticated: true, loading: false, username: res.data.authData.user.username });
      })
      .catch((err) => {
        console.log(err);
        console.log(`Access: ${this.state.isAuthenticated}`);
      });
    this.fetchDashboardData();
    this.fetchAttendanceData();
  }

  fetchAttendanceData = () => {
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    axios
      .get("/attendance/attendanceForDesktop", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        console.log("res--", res?.data?.records);
        this.setState({ attendanceData: res?.data?.records, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error fetching items",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };


  fetchDashboardData = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const [leavesToday, restDays, attendance] = await Promise.all([
        axios.get("/applications/today", { headers }).catch((err) => {
          return { data: [] };
        }),
        axios.get("/restdays/today", { headers }).catch((err) => {
          return { data: [] };
        }),
        axios.get("/attendance/today-summary", { headers }).catch((err) => {
          return { data: {} };
        }),
      ]);
      this.setState({
        leavesToday: leavesToday.data || [],
        restDays: restDays.data || [],
        attendance: attendance.data || {},
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      this.setState({ loading: false });
    }
  };


  updateAttendance = (data) => {
    this.setState({ showModal: true, selectedAttendance: { ...data } });
  };
  handleConfirm = () => {
    this.setState({ showModal: true });
  };


  handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "password") {
      this.setState({ password: value });
      return;
    }
    this.setState((prevState) => {
      const updatedAttendance = {
        ...prevState.selectedAttendance,
        [name]: value,
      };
      if (name === "startTime" || name === "endTime") {
        updatedAttendance.numberOfHours = this.calculateHours(
          updatedAttendance.startTime,
          updatedAttendance.endTime
        );
      }
      return { selectedAttendance: updatedAttendance };
    });
  };


  handleConfirmUpdate = () => {
    Modal.confirm({
      title: "Are you sure you want to update attendance?",
      content: "Please confirm before proceeding.",
      onOk: () => {
        this.setState({ showPasswordField: true });
      },
      onCancel: () => {
        this.setState({ showPasswordField: false });
      },
      okText: "Yes, Update",
      cancelText: "Cancel",
    });
  };
  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };


  handleUpdateAttendance = async () => {
    const { selectedAttendance, password, showPasswordField } = this.state;
    if (!showPasswordField) {
      this.handleConfirmUpdate();
      return;
    }
    if (!password) {
      this.setState({ showToast: true, toastMessage: "Please enter a password before updating attendance.", toastVariant: "danger", color: 'red' });
      return;
    }
    const attendancePayload = {
      id: selectedAttendance?.id,
      startTime: selectedAttendance?.startTime,
      endTime: selectedAttendance?.endTime,
      username: this.state.username,
      password: password
    };
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", showModal: false });
        return;
      }
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(`/attendance/updatepass`, attendancePayload, { headers });

      if (response.status === 200) {
        this.setState({
          showToast: true,
          toastMessage: "Attendance updated successfully",
          toastVariant: "success",
          color: 'green',
          showModal: false,
          showPasswordField: false,
          password: ""
        });
        this.fetchAttendanceData();
      } else {
        this.setState({ showToast: true, toastMessage: "Failed to update attendance", toastVariant: "danger", color: 'red' });
      }
    } catch (error) {
      console.error("Error updating attendance:", error);
      this.setState({ showToast: true, toastMessage: "Invalid Credentials ", toastVariant: "danger", color: 'red' });
    }
  };


  calculateHours = (startTime, endTime) => {
    if (!startTime || !endTime) return "";
    const start = startTime.split(":").map(Number);
    const end = endTime.split(":").map(Number);
    const startSeconds = start[0] * 3600 + start[1] * 60 + (start[2] || 0);
    const endSeconds = end[0] * 3600 + end[1] * 60 + (end[2] || 0);
    let diff = endSeconds - startSeconds;
    if (diff < 0) {
      diff += 24 * 3600;
    }
    const hours = (diff / 3600).toFixed(2);
    return hours;
  };

  render() {
    const columns = [
      { key: "empid", label: "Employee Id" },
      { key: "employeeName", label: "Full Name" },
      { key: "jobTitle", label: "Job Title" },
      { key: "projectName", label: "Project Name" },
      {
        key: "date",
        label: "Date",
        render: (value) => DateTimeFormat(value),
      },
      { key: "startTime", label: "In Time" },
      { key: "endTime", label: "Out Time" },
      { key: "numberOfHours", label: "Hours" },

      {
        key: "actions",
        label: "Action",
        render: (value, row) => (
          <div>
            {
              hasPermission('M11B1') && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-edit-${row?.id}`}>Update Attendance</Tooltip>}
                >
                  <Button
                    size="sm"
                    variant="outline-info"
                    className='info'
                    onClick={() => this.updateAttendance(row)}
                  >
                    <i className="fas fa-edit"></i>
                  </Button>
                </OverlayTrigger>
              )
            }
          </div>
        ),
      },
    ];


    const visibleCards = [];
    if (hasPermission("DashD1") && this.state.leavesToday?.length) {
      visibleCards.push({
        key: "leave",
        content: <TodayLeave leaves={this.state.leavesToday} />
      });
    }
    if (hasPermission("DashD3") && Object.keys(this.state.attendance || {}).length) {
      visibleCards.push({
        key: "attendance",
        content: <TodayAttendance attendance={this.state.attendance} />
      });
    }
    if (hasPermission("DashD2") && this.state.restDays?.length) {
      visibleCards.push({
        key: "rest",
        content: <TodayRestDays restDays={this.state.restDays} />
      });
    }

    const colSize = visibleCards.length === 1 ? 12 : visibleCards.length === 2 ? 6 : 4;

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4 px-3">
            <Row>
              {visibleCards.length !== 0 ? (
                visibleCards.slice(0, 5).map(card => (
                  <Col md={colSize} key={card.key} className="mb-4">
                    <div
                      style={{
                        maxHeight: "70vh",
                        overflowY: "auto",
                        scrollbarWidth: "thin",
                      }}
                    >
                      <div>
                        {Array.isArray(card.content) ? (
                          <>
                            {card.content.slice(0, 5).map((item, index) => (
                              <div key={index}>{item}</div>
                            ))}
                            {card.content.length > 5 && (
                              <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                                {card.content.slice(5).map((item, index) => (
                                  <div key={index + 5}>{item}</div>
                                ))}
                              </div>
                            )}
                          </>
                        ) : (
                          card.content
                        )}
                      </div>
                    </div>
                  </Col>
                ))
              ) : (
                <Col md={12}>
                  <Card>
                    <Card.Body>
                      <Card.Text>
                        <strong className="text-danger d-flex justify-content-center align-items-center"
                          style={{ height: "100px" }}>
                          Dashboard Data not available!
                        </strong>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              )}
              <Col md={12}>
                {
                  hasPermission('DashD4') && (
                    <Card className="shadow-sm rounded border-0 mt-3">
                      <Card.Header>
                        <b>Checkout Pending List</b>
                      </Card.Header>
                      <Card.Body>
                        <CommonTableModule
                          columns={columns}
                          data={this.state.attendanceData}
                        />
                      </Card.Body>
                    </Card>
                  )
                }
              </Col>
            </Row>
          </div>
          <Modal
            title="Update Attendance"
            open={this.state.showModal}
            onCancel={() => this.setState({ showModal: false, showPasswordField: false })}
            onOk={this.handleUpdateAttendance}
            okText={this.state.showPasswordField ? "Save" : "Confirm Update"}
            cancelText="Cancel"
          >
            {this.state.selectedAttendance && (
              <Form>
                {this.state.showPasswordField && (
                  <Form.Group>
                    <Form.Label className='required'>Enter Password</Form.Label>
                    <div style={{ position: "relative" }}>
                      <Form.Control
                        type={this.state.showPassword ? "text" : "password"}
                        onChange={this.handleInputChange}
                        value={this.state.password}
                        name="password"
                        placeholder="Enter Your Login Password"
                        required
                      />
                      <span
                        onClick={this.togglePasswordVisibility}
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "10px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#6c757d"
                        }}
                      >
                        {this.state.showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </Form.Group>
                )}
                {
                  !this.state.showPasswordField && (
                    <>
                      <Form.Group>
                        <Form.Label>Employee ID</Form.Label>
                        <Form.Control type="text" value={this.state.selectedAttendance.empid} readOnly />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Employee Name</Form.Label>
                        <Form.Control type="text" value={this.state.selectedAttendance.employeeName} readOnly />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Start Time</Form.Label>
                        <Form.Control
                          type="time"
                          step="1"
                          name="startTime"
                          value={this.state.selectedAttendance.startTime}
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>End Time</Form.Label>
                        <Form.Control
                          type="time"
                          step="1"
                          name="endTime"
                          value={this.state.selectedAttendance.endTime}
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Number of Hours</Form.Label>
                        <Form.Control type="text" value={this.state.selectedAttendance.numberOfHours} readOnly />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Location</Form.Label>
                        <Form.Control as="textarea"
                          rows={3} value={this.state.selectedAttendance.location} readOnly />
                      </Form.Group>
                    </>)}
              </Form>
            )}
          </Modal>
        </CommonLoader>
      </>
    );
  }
}